import React, { useEffect } from 'react'
import styled, { css } from 'styled-components'
import { Variables } from '../styles/Variables'
import media from 'css-in-js-media'
import { Field, FieldProps } from 'formik'

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
    // Hide checkbox visually but remain accessible to screen readers.
    // Source: https://polished.js.org/docs/#hidevisually
    border: 0;
    clip: rect(0 0 0 0);
    clippath: inset(50%);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;
`

const Icon = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    opacity: 0;
`

export const CheckboxContainer = styled.div`
    display: inline-block;
    vertical-align: middle;
    margin: 0;
    margin-bottom: 20px;
`

const checkedStyles = css`    
    ${Icon} {
        opacity: 1;
    }
`
const uncheckedStyles = css`
    background-color: ${Variables.color.white};
`

export const StyledCheckbox = styled.div`
    display: inline-block;
    border: 1px solid ${Variables.color.border};
    border-radius: 0;
    height: 30px;
    width: 30px;
    min-width: 30px;
    background: none;
    color: ${Variables.color.lightGrey};
    cursor: pointer;
    background-color: ${Variables.color.white};

    ${media('<desktop')} {
        width: 40px;
        height: 40px;
    }

    ${(props: { checked: any }) => (props.checked ? checkedStyles : uncheckedStyles)};
`

export const Label = styled.span`
    display: inline-block;
    vertical-align: middle;
    margin-left: 10px;
    cursor: pointer;        
    color: ${Variables.color.white} ;
    font-family: ${Variables.font.body};
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 120%;

    ${media('<desktop')} {
        margin-left: 20px;
        font-size: 16px;
        line-height: 28px;
        letter-spacing: 0.005em;
    }
`

const LabelWrap = styled.label`
    display: flex;
    align-items: center;
`

interface Props {
    name: string;
    label: string;
    disabled: boolean;
}

const Checkbox = ({ name, label, disabled }:Props) => {
    return (
        <Field
            name={name}
            render={({ field }: FieldProps) => (
                <CheckboxContainer>
                    <LabelWrap>
                        <HiddenCheckbox
                            checked={field.value}
                            {...field}
                            disabled={disabled}
                        />
                        <StyledCheckbox checked={field.value}>
                            <Icon>
                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="10" height="10" fill="#14323C"/>
                                </svg>
                            </Icon>
                        </StyledCheckbox>
                        <Label
                            dangerouslySetInnerHTML={{
                                __html: label,
                            }}
                        />
                    </LabelWrap>
                </CheckboxContainer>
            )}
        />
    )
}

export default Checkbox
